export const SHOW_DISABLE_TWO_FACTOR_MODAL = 'SHOW_DISABLE_TWO_FACTOR_MODAL';
export const HIDE_DISABLE_TWO_FACTOR_MODAL = 'HIDE_DISABLE_TWO_FACTOR_MODAL';

export const RECEIVE_LDAP_OVERRIDE_SUCCESS = 'RECEIVE_LDAP_OVERRIDE_SUCCESS';
export const RECEIVE_LDAP_OVERRIDE_ERROR = 'RECEIVE_LDAP_OVERRIDE_ERROR';

export const SHOW_LDAP_OVERRIDE_CONFIRMATION_MODAL = 'SHOW_LDAP_OVERRIDE_CONFIRMATION_MODAL';
export const HIDE_LDAP_OVERRIDE_CONFIRMATION_MODAL = 'HIDE_LDAP_OVERRIDE_CONFIRMATION_MODAL';
